export default __webpack_public_path__ + "static/media/swap_icon.70048bf0.svg";